import { c as _c } from "react/compiler-runtime";
import { getEntitiesByFpIdOptions } from '@onefootprint/fetch-dashboard';
import { useQueries } from '@tanstack/react-query';
import { entityDisplayName } from './entity-resource-name';

// Batch-resolve readable names for a set of entity fp_ids (names are sensitive vault data absent from
// the resource frame). Returns a map of fp_id → name for those that resolved to a real one; callers
// fall back to the fp_id otherwise. The Context Explorer uses this so it can both display and *search
// by* the shown name — a per-row fetch would only know the name after the filter had already run.
export const useEntityNames = fpIds => {
  const $ = _c(7);
  let t0;
  if ($[0] !== fpIds) {
    t0 = fpIds.map(_temp);
    $[0] = fpIds;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = {
      queries: t0
    };
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const results = useQueries(t1);
  let names;
  if ($[4] !== fpIds || $[5] !== results) {
    names = new Map();
    fpIds.forEach((fpId_0, i) => {
      const entity = results[i]?.data;
      const name = entity ? entityDisplayName(entity) : null;
      if (name) {
        names.set(fpId_0, name);
      }
    });
    $[4] = fpIds;
    $[5] = results;
    $[6] = names;
  } else {
    names = $[6];
  }
  return names;
};
function _temp(fpId) {
  return {
    ...getEntitiesByFpIdOptions({
      path: {
        fpId
      }
    }),
    enabled: !!fpId
  };
}